/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useEffect, useState } from 'react';

const input = require('b_').with('input');

export const RadioButtons = ({
    id: groupName, metaData, value, onChange, required, disabled, error, type, onBlur,
}) => {
    const [ items, changeSelection ] = useState([]);

    useEffect(
        () => {
            changeSelection(metaData && metaData.map(e => ({ ...e, active: e.id === value })));
        },
        [ metaData, value ],
    );

    const onChangeHandler = (v) => {
        changeSelection(items.map(ee => ({ ...ee, active: ee.id === v })));
        onChange(v);
    };
    return (
        <React.Fragment>
            {items &&
                items.map(({ id, active, name }) => (
                    <RadioButton
                        groupName={groupName}
                        key={id}
                        id={`${groupName}-${id}`}
                        value={id}
                        required={required}
                        disabled={disabled}
                        error={error}
                        checked={active}
                        label={name}
                        type={type}
                        onChange={onChangeHandler}
                        onBlur={onBlur}
                    />
                ))}
        </React.Fragment>
    );
};

export const RadioButton = ({
    id,
    value,
    required,
    disabled,
    error,
    checked,
    label,
    onChange,
    onBlur,
    mods,
    groupName,
}) => (
    <span className={input('radio-wrapper')}>
        <input
            name={groupName}
            id={id}
            required={required}
            disabled={disabled}
            className={input({ radio: true, error: !!error, ...mods })}
            type="radio"
            value={value}
            onChange={() => onChange(value)}
            onBlur={onBlur}
            checked={checked}
            readOnly
        />
        <label
            className={input('label', { radio: true, required: !!required, ...mods })}
            htmlFor={id}
        >
            {label}
        </label>
    </span>
);
